import { render, staticRenderFns } from "./FooterTabbar.vue?vue&type=template&id=0cb3b268&scoped=true&"
import script from "./FooterTabbar.vue?vue&type=script&lang=js&"
export * from "./FooterTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3b268",
  null
  
)

export default component.exports